import React from 'react';
import { DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import { Typography, Grid } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { StyledDialog } from 'components/InvoiceFeeNoteDialog/styles';
import { translate } from 'containers/services/translate';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import messages from 'containers/LawyerFeeNote/messages';

export interface RejectFeeNoteByLawyerDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  handleValidate: Function;
}

const RejectFeeNoteByLawyerDialog: React.FC<RejectFeeNoteByLawyerDialogProps> = (
  props,
): JSX.Element => {
  const { onClose, open } = props;
  const handleClose = () => {
    onClose(false);
  };

  return (
    <StyledDialog onClose={handleClose} open={open}>
      <DialogTitle>
        <Grid
          container
          direction="row"
          alignItems="center"
          justify="space-between"
        >
          <Grid item xs={9}>
            <span
              style={{
                color: '#172C51 !important',
                fontSize: '20px',
                lineHeight: '24.42px',
              }}
            >
              {translate(messages.rejectFeeNoteTitle, props)}
            </span>
          </Grid>
          <Grid item>
            <CloseIcon onClick={handleClose} data-testId="close-icon" />
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          direction="row"
          alignItems="center"
          alignContent="center"
          spacing={1}
        >
          <Typography>
            {translate(messages.rejectFeeNoteDescription, props)}
          </Typography>
        </Grid>
      </DialogContent>
      <DialogActions className="success-actions">
        <SecondaryButton
          onClick={() => props.onClose()}
          disableElevation
          data-testId="cancel-button"
          title={translate(messages.cancel, props)}
        />
        <PrimaryButton
          onClick={() => props.handleValidate()}
          disableElevation
          data-testId="validate-button"
          className="primary-button"
          title={translate(messages.confirm, props)}
        />
      </DialogActions>
    </StyledDialog>
  );
};

export default injectIntl(RejectFeeNoteByLawyerDialog);
